import _ from 'lodash'
import dayjs from 'dayjs'

// 分转元
export function fenToYuan (value) {
  value = _.toNumber(value)
  return _.round(value / 100, 2)
}
export function fenToYuanDiscount (value, discount) {
  value = _.toNumber(value)
  return _.round((value / 100 * discount) / 100, 2)
}

// 日期格式化
export function dateFormat (value, format = 'YYYY-MM-DD') {
  return dayjs(value).format(format)
}

// 判断是否则日期之前
export function isBefore (dateValue) {
  return dayjs().isBefore(dayjs(dateValue))
}

export function parseText (text, member) {
  const lines = text.split('\n')
  const preamble = [] // 第一个 <h> 之前的内容（每行一个元素，保留原格式，但可选 trim）
  const headers = []
  const contents = []

  let currentContent = []
  let inMainBody = false // 标记是否已进入第一个 <h> 之后的部分

  for (const line of lines) {
    const trimmed = line.trim()
    // 检查是否是 <h>...</h> 行（允许前后有空格）
    const match = trimmed.match(/^<h>(.+)<\/h>$/)

    if (match) {
      // 遇到第一个 <h>，将 preamble 锁定，之后的内容归入主结构
      inMainBody = true

      // 保存前一个章节的内容（如果是第一个 <h>，则 currentContent 为空）
      if (headers.length > 0 || currentContent.length > 0) {
        contents.push(currentContent)
      }

      headers.push(match[1])
      currentContent = []
    } else {
      if (!inMainBody) {
        // 还没遇到第一个 <h>，收集到 preamble（保留原始行，或可选 trim）
        // 这里保留原始行，但跳过纯空行（可按需调整）
        if (trimmed !== '') {
          preamble.push(line.replace('{member}', member)) // 或 push(trimmed) 如果你希望去空格
        }
      } else {
        // 在主结构中，只收集非空行（按你的需求）
        if (trimmed !== '') {
          currentContent.push(trimmed)
        }
      }
    }
  }

  // 处理最后一个章节的内容
  if (inMainBody && (currentContent.length > 0 || headers.length > contents.length)) {
    contents.push(currentContent)
  }

  return {
    preamble, // Array<string>：第一个 <h> 之前的所有非空行（原始行）
    headers, // Array<string>：<h> 标题
    contents // Array<Array<string>>：每个标题下的内容行
  }
}
